import Vue from 'vue'

/**
 * 当一个元素已处于拖拽情况下，鼠标移到了某些通过 hover 反馈的元素，但此时往往不需要反馈，可以通过
 * 是否 dragging 决定
 */
const draggingState = Vue.observable({
  dragging: false,
})

export default {
  computed: {
    hasGlobalDragging() {
      return draggingState.dragging
    },
  },
  methods: {
    setGlobalDragging(dragging) {
      draggingState.dragging = dragging
    },
  },
}
